import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <header [class.scrolled]="scrolled">
      <div class="container">
        <div class="header-content">
          <div class="logo">
            <a href="#">
              <span class="logo-text">Zero-Waste</span>
            </a>
          </div>
          <nav [class.active]="menuActive">
            <ul>
              <li><a routerLink="/about-us">Pourquoi nous ?</a></li>
              <li>
                <a routerLink="/how-it-works-marketplace">Comment ça marche</a>
              </li>
              <li><a href="#testimonials">Témoignages</a></li>
              <li>
                <a (click)="navigateToContact()" style="cursor: pointer;"
                  >Contact Us</a
                >
              </li>
            </ul>
          </nav>
          <div class="header-buttons">
            <a
              href="https://store.zero-waste.pro/login"
              class="btn-home btn-secondary-home"
              >Se connecter</a
            >
            <a
              class="btn-home btn-primary-home"
              (click)="goToStorePage()"
              (keyup.enter)="goToStorePage()"
              tabindex="0"
              >Rejoindre Zero-Waste</a
            >
          </div>
          <div
            class="mobile-menu-toggle"
            (click)="toggleMenu()"
            (keyup.enter)="toggleMenu()"
            tabindex="0"
          >
            <i
              class="fas"
              [class.fa-bars]="!menuActive"
              [class.fa-times]="menuActive"
            ></i>
          </div>
        </div>
      </div>
    </header>
  `,
  styles: [
    `
      header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        padding: 20px 0;
        z-index: 1000;
        transition: all 0.3s ease;
        background-color: transparent;
      }

      header.scrolled {
        background-color: var(--light-color);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        padding: 15px 0;
      }

      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .logo a {
        display: flex;
        align-items: center;
        color: var(--primary-color);
        font-weight: 700;
        font-size: 1.8rem;
      }

      .logo-text {
        margin-left: 8px;
      }

      nav ul {
        display: flex;
        list-style: none;
      }

      nav ul li {
        margin: 0 15px;
      }

      nav ul li a {
        color: var(--text-color);
        font-weight: 500;
        position: relative;
      }

      nav ul li a::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 0;
        height: 2px;
        background-color: var(--primary-color);
        transition: width 0.3s ease;
      }

      nav ul li a:hover::after {
        width: 100%;
      }

      .header-buttons {
        display: flex;
        gap: 15px;
      }

      .mobile-menu-toggle {
        display: none;
        cursor: pointer;
        font-size: 1.5rem;
      }

      @media (max-width: 992px) {
        .header-buttons .btn-secondary {
          display: none;
        }
      }

      @media (max-width: 768px) {
        .mobile-menu-toggle {
          display: block;
        }

        nav {
          position: fixed;
          top: 80px;
          left: -100%;
          width: 100%;
          height: calc(100vh - 80px);
          background-color: var(--light-color);
          transition: all 0.3s ease;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        nav.active {
          left: 0;
        }

        nav ul {
          flex-direction: column;
          text-align: center;
        }

        nav ul li {
          margin: 20px 0;
        }

        .header-buttons {
          display: none;
        }
      }
    `,
  ],
})
export class HeaderComponent {
  scrolled = false;
  menuActive = false;

  constructor(private readonly router: Router) {
    window.addEventListener('scroll', this.onWindowScroll.bind(this));
  }

  goToStorePage() {
    this.router.navigate(['create-account']).then();
  }

  navigateToContact() {
    // Si nous ne sommes pas sur la page d'accueil, d'abord y aller
    if (this.router.url !== '/show') {
      this.router.navigate(['/show']).then(() => {
        // Une fois sur la page d'accueil, attendre un peu et scroller vers la section
        setTimeout(() => {
          const element = document.getElementById('contact-us');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      });
    } else {
      // Si nous sommes déjà sur la page d'accueil, juste scroller
      const element = document.getElementById('contact-us');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // Fermer le menu mobile si ouvert
    this.menuActive = false;
  }

  onWindowScroll() {
    this.scrolled = window.scrollY > 50;
  }

  toggleMenu() {
    this.menuActive = !this.menuActive;
  }
}
